<template>
    <div class="dataStatistics">
        <div class="title-box">
            <img class="cion" src="@/assets/home/dateLeft-icon.png"></img>
            <span>年龄段分布</span>
        </div>
        <div class="cont-box2">
            <chartBar v-if="processedData" :chartDate="processedData" height="250px" width="100%"></chartBar>
        </div>
    </div>
</template>

<script>
    import drawMixin from "@/utils/drawMixin";
    import chartBar from '@/components/home/chartBarAge.vue';

    import {
        formatTime
    } from "@/utils/index.js";

    import { ageGenderStatistics } from '@/api/common.js'
    export default {
        // mixins: [drawMixin],
        data() {
            return {
                num: '232',
                chartDate: {},
                originalData: {},
                processedData: null,
            };
        },
        components: {
            chartBar
        },
        mounted() {


        },
        beforeDestroy() {

        },
        created() {
            this.init()
        },
        methods: {
            init() {
                let obj = {
                    xAxis: ['10岁', '20岁', '30岁', '40岁', '50岁', '60岁及以上'],
                    data1: [15, 20, 12, 30, 45, 26],
                    data2: [18, 28, 18, 38, 48, 28],

                }
                this.chartDate = obj

                ageGenderStatistics().then(res => {
                    // console.log('年龄分布段', res)
                    if (res.code == 200) {
                        this.originalData = res.data
                        this.$nextTick(v=>{
                            this.processData()
                        })
                    }
                })
            },
            processData() {
                const xAxis = ['10岁', '10-19岁', '20-29岁', '30-39岁', '40-49岁', '50-59岁', '60岁及以上'];
                const data1 = []; // 男性数量
                const data2 = []; // 女性数量

                // 遍历原始数据并提取值
                for (const key in this.originalData) {
                    if (this.originalData.hasOwnProperty(key)) {
                        const value = this.originalData[key];
                        switch (key) {
                            case 'under10':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'age10to19':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'age20to29':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'age30to39':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'age40to49':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'age50to59':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                            case 'over60':
                                data1.push(value.maleCount);
                                data2.push(value.femaleCount);
                                break;
                        }
                    }
                }

                // 组装最终的数据结构
                this.processedData = {
                    xAxis,
                    data1,
                    data2
                };
                // console.log('组装最终的数据结构',this.processedData)
            }
        },
    };
</script>

<style lang="scss" scoped>
    /* @import "../../../assets/scss/index.scss"; */

    .dataStatistics {
        /* background-image: url(../../../assets/home/bg-1.png); */
        background: linear-gradient( 180deg, rgba(32,65,116,.3) 0%, rgba(113,161,246,.3) 100%);
        background-size: 100% 100%;
        margin-bottom: 10px;
        width: 100%;

        .title-box {
            width: 100%;
            height: 42px;
            background-image: url(../../../assets/home/title-box-bg.png);
            background-size: 100% 100%;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            align-items: center;

            .cion {
                width: 34px;
                height: 35px;
                margin-right: 10px;
            }
        }

        .cont-box2 {
            width: 100%;
            padding: 13px 20px 10px 20px;
        }





    }
</style>